import * as AllWidgetBlocks from './WidgetBlocks';

const all = Object.keys(AllWidgetBlocks).map((widgetId) => AllWidgetBlocks[widgetId]);

export { all };
export * from './WidgetBlocks';
